module.exports = __webpack_public_path__ + "static/media/Poppins-Bold.922cb3bc.ttf";